/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { CountryModelDto, ErrorResponseModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CountriesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Countries
   * @name CountriesGet
   * @summary Returns the country list.
   * @request GET:/countries
   */
  countriesGet = (params: RequestParams = {}) =>
    this.http.request<CountryModelDto[], ErrorResponseModelDto>({
      path: `/countries`,
      method: "GET",
      format: "json",
      ...params,
    });
}
